// (A) 중립 아이콘 API — antd 미접촉. name(registry key)만 노출.
// (B) PlainIcon 이 name → 인라인 SVG(antd Outlined glyph 파리티)로 매핑. 중립 name registry 단일 창구(icon-mapping.md).
import type { CSSProperties } from 'react'
import { PlainIcon } from '../_impl/PlainIcon'

// 실사용 아이콘 인벤토리(B5, 58파일 / 고유 25종). 중립 name → antd/lucide 대응은 icon-mapping.md.
export type OmwIconName =
  | 'arrowLeft'
  | 'check'
  | 'checkCircle'
  | 'close'
  | 'copy'
  | 'delete'
  | 'down'
  | 'download'
  | 'edit'
  | 'exclamationCircle'
  | 'expand'
  | 'eye'
  | 'loading'
  | 'loadingCircle'
  | 'mail'
  | 'minus'
  | 'more'
  | 'moreVertical'
  | 'plus'
  | 'reload'
  | 'search'
  | 'setting'
  | 'team'
  | 'up'
  | 'user'

export interface OmwIconProps {
  name: OmwIconName
  spin?: boolean
  className?: string
  style?: CSSProperties
}

export function OmwIcon(props: OmwIconProps) {
  return <PlainIcon {...props} />
}
